import React from 'react';
import { useSelector } from 'react-redux';
import { path, defaultTo, assoc } from 'ramda';
import pureEnhance from '@ux/pure-enhance';
import { injectIntl } from 'react-intl';

// so much more complicated as a package, so we have an inline selector here

var getLanguage = path(['language', 'language', 'preferred']); // for some reason injectIntl doesn't force the component to update when locale/messages change
// so we have to pass the user's language in as a key, so it re-renders whenever this prop changes

var withKey = function withKey(props) {
  var defaultKey = props.intl.locale;
  var key = defaultTo(defaultKey, useSelector(getLanguage));
  return assoc('key', key, props);
};

var PureSimpleMessage = function PureSimpleMessage(_ref) {
  var id = _ref.id,
      intl = _ref.intl;
  return React.createElement("span", null, intl.messages[id] || id);
};

var SimpleMessage = pureEnhance('SimpleMessage', {
  hocs: [injectIntl],
  hooks: [withKey]
})(PureSimpleMessage);

export default SimpleMessage;
